import React from 'react'
import {Redirect} from 'react-router-dom'
import Snackbar from 'material-ui-legacy/Snackbar'
import ActionCompareArrows from 'material-ui-legacy/svg-icons/action/compare-arrows'
import ActionCheckCircle from 'material-ui-legacy/svg-icons/action/check-circle'
import {deepOrange500, lightGreenA700} from 'material-ui-legacy/styles/colors'

import auth from '../../stores/auth.js'
import errors from '../../lib/errors.js'
import ErrorDialog from '../UI/ErrorDialog'
import UserForm from './UserForm'

import Resource from '../../stores/resource'
const UserStore = Resource('users')


/*
Props:
- user: a full User object
- savedCallback: function(userObject) - called when a user is successfully saved
- myAccount: Boolean(false) - change form behaviours if user is in /my-account
*/
class EditUser extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      user: (this.props.user || {}),
      changed: false,
      saved: false,
      error: '',
      snackbarMessage: ''
    }
  }

  _save = (attributes) => {
    // Adjust phones
    attributes.phones = {
      office: attributes.officePhone,
      mobile: attributes.mobilePhone
    }

    // Remove display-only fields
    delete attributes.mobilePhone
    delete attributes.officePhone

    // Password management - remove key if not changing it
    if (!attributes.password) delete attributes.password
    delete attributes.passwordConfirmation

    // Non-admin users can't change roles, so we need to deal with that
    if (!auth.isAdmin()) delete attributes.roles

    // Save!
    const fullName = `${attributes.firstName} ${attributes.lastName}`
    UserStore.update(this.state.user.id, attributes)
    .then((result) => {
      this.setState({
        saved: true,
        changed: false,
        error: '',
        savedUser: result.data.data,
        snackbarMessage: `User "${fullName}" saved!`
      },
      () => {
        if (this.props.savedCallback) {
          this.props.savedCallback(this.state.savedUser)
        }
      })
    })
    .catch((error) => {
      this.setState({
        saved: false,
        error: errors.unpack(error)
      })
    })
  }

  _changed = (didChange) => this.setState({changed: didChange, saved: false})

  _closeErrorDialog = () => this.setState({error: ''})

  _resetSnackbar = () => this.setState({snackbarMessage: ''})

  _redirectTo = (url) => this.setState({redirect: url})

  render() {
    const {
      user,
      changed,
      saved,
      error,
      snackbarMessage,
      redirect
    } = this.state

    if (redirect) return <Redirect push to={redirect}/>

    return (
      <section>
        <UserForm
          formTitle={
            <span>
              {user.attributes.fullName}&nbsp;
              {changed && <ActionCompareArrows color={deepOrange500}/>}
              {saved && <ActionCheckCircle color={lightGreenA700}/>}
            </span>
          }
          user={user}
          myAccount={this.props.myAccount}
          changedCallback={this._changed}
          submitCallback={this._save}
          cancelCallback={() => this._redirectTo("/users")}
        />

        <Snackbar
          open={Boolean(snackbarMessage)}
          message={snackbarMessage}
          autoHideDuration={4000}
          onRequestClose={this._resetSnackbar}
        />

        <ErrorDialog
          open={Boolean(error)}
          closeCallback={this._closeErrorDialog}
          title="Couldn't save your changes">
          <p>
            The user <strong>{user.attributes.fullName}</strong> remains unchanged.
          </p>
          <p>
            <strong>Error:</strong> {error}
          </p>
        </ErrorDialog>
      </section>
    )
  }
}

export default EditUser



// WEBPACK FOOTER //
// ./src/components/Users/EditUser.jsx